import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, Text, Box, Anchor } from 'grommet';
import { FormClose } from 'grommet-icons';

import { Placeholder } from '../../../../components';
import { TitleDetail, Wrapper, Statistic, SimpleDetail, Hr } from '../../../../components/detail';

import { toggleInsightsLayer } from '../../actions/insights';

import visibleWidth from '../../../../constants/layer-width';

import { formattedCurrency, chooseColor } from '../../../../utils';

const InsightsAmendment = (props) => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const {
    detail,
    getDetailError,

    toggleLayer,
    toggleInsightsLayer,
  } = props;


  if(!toggleLayer || toggleLayer !== 'insights') {
    return null;
  }

  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Layer
          responsive={false}
          full='vertical'
          position='left'
          onClickOutside={toggleInsightsLayer}
          onEsc={toggleInsightsLayer}
        >
          <Box
            fill='vertical'
            width={visibleWidth[size]}
            pad={{ top: 'large', bottom: 'xsmall' }}
            overflow='auto'
            flex
          >
            {getDetailError ? (
              <Placeholder
                title='Ops! Algo deu errado :('
                message='Estamos constrangidos por isso.'
                button={{
                  label: 'Fechar',
                  action: toggleInsightsLayer,
                }}
              />
            ) : null}

            {!detail && !getDetailError ? (
              <Placeholder
                title='Carregando...'
                message='Aguarde que estamos preparando as coisas :)'
              />
            ) : null}


            {detail ? (
              <>
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail value='Estatísticas' />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={toggleInsightsLayer}
                  />
                </Box>


                <Box flex overflow='auto'>
                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    flex={{ shrink: 0 }}
                  >
                    <Text color='dark-2' size='small'>
                      Confira abaixo os principais dados sobre as emendas parlamentares cadastradas.
                      Utilize o filtro por ano para visualizar as estatísticas específicas de cada período.
                    </Text>
                  </Box>


                  <Box
                    gap={ size === 'small' ? 'medium' : 'small' }
                    margin={{
                      vertical: 'small',
                      horizontal: 'large',
                    }}
                    direction='row'
                    flex={{ shrink: 0 }}
                  >
                    {/*<Box
                      background={'active'}
                      round='medium'
                      pad={{
                        horizontal: size === 'small' ? 'small' : 'medium',
                        vertical: size === 'small' ? 'xxsmall' : 'xxsmall',
                      }}
                    >
                      <Anchor
                        size='small'
                        color='dark-1'
                        label='2024'
                        disabled={selectedYear === 2024}
                        onClick={() => {
                          setSelectedYear(2024)
                        }}
                      />
                    </Box>*/}

                    {/*<Box
                      background={'active'}
                      round='medium'
                      pad={{
                        horizontal: size === 'small' ? 'small' : 'medium',
                        vertical: size === 'small' ? 'xxsmall' : 'xxsmall',
                      }}
                    >
                      <Anchor
                        size='small'
                        color='dark-1'
                        label='2025'
                        disabled={selectedYear === 2025}
                        onClick={() => {
                          setSelectedYear(2025)
                        }}
                      />
                    </Box>*/}

                    <Box
                      background={'active'}
                      round='medium'
                      pad={{
                        horizontal: size === 'small' ? 'small' : 'medium',
                        vertical: size === 'small' ? 'xxsmall' : 'xxsmall',
                      }}
                    >
                      <Anchor
                        size='small'
                        color='dark-1'
                        label='2026'
                        disabled={selectedYear === 2026}
                        onClick={() => {
                          setSelectedYear(2026)
                        }}
                      />
                    </Box>
                  </Box>


                  {/* Geral */}
                  <SimpleDetail
                    title='Valor total'
                    value={formattedCurrency(detail.totais.value)}
                  />

                  <SimpleDetail
                    title='Cadastradas nesse ano'
                    value={detail.totais.total}
                  />

                  <Hr />


                  {/* Secretarias */}
                  <Wrapper
                    value={
                      <Text
                        size='medium'
                        textAlign='start'
                        color='dark-3'
                      >
                        Secretarias
                      </Text>
                    }
                  />

                  <Box
                    flex={{ shrink: 0 }}
                    border={ { color: 'light-5', size: 'xsmall' } }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    pad={{ horizontal: 'medium', vertical: 'medium' }}
                    round='small'
                    gap='small'
                  >
                    {detail.secretary.map((item, index) => (
                      <Statistic
                        key={index}
                        title={item.name}
                        graph={{
                          value: item.value / detail.totais.value,
                          color: chooseColor(index),
                        }}
                        label={{
                          value: item.value,
                          formatter: 'currency',
                        }}
                      />
                    ))}
                  </Box>


                  {/* Regiões */}
                  <Wrapper
                    value={
                      <Text
                        size='medium'
                        textAlign='start'
                        color='dark-3'
                      >
                        Regiões
                      </Text>
                    }
                  />

                  <Box
                    flex={{ shrink: 0 }}
                    border={ { color: 'light-5', size: 'xsmall' } }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    pad={{ horizontal: 'medium', vertical: 'medium' }}
                    round='small'
                    gap='small'
                  >
                    {detail.region.map((item, index) => (
                      <Statistic
                        key={index}
                        title={item.name}
                        graph={{
                          value: item.value / detail.totais.value,
                          color: chooseColor(index),
                        }}
                        label={{ value: item.value, formatter: 'decimal' }}
                      />
                    ))}
                  </Box>


                  {/* Estágios */}
                  <Wrapper
                    value={
                      <Text
                        size='medium'
                        textAlign='start'
                        color='dark-3'
                      >
                        Estágios
                      </Text>
                    }
                  />

                  <Box
                    flex={{ shrink: 0 }}
                    border={ { color: 'light-5', size: 'xsmall' } }
                    margin={{ vertical: 'small', horizontal: 'large' }}
                    pad={{ horizontal: 'medium', vertical: 'medium' }}
                    round='small'
                    gap='small'
                  >
                    {detail.stage.map((item, index) => (
                      <Statistic
                        key={index}
                        title={item.name}
                        graph={{
                          value: item.value / detail.totais.value,
                          color: chooseColor(index),
                        }}
                        label={{
                          value: item.value,
                          formatter: 'decimal',
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              </>
            ) : null}
          </Box>
        </Layer>
      )}
    </ResponsiveContext.Consumer>
  );
}

const mapStateToProps = ({ layerDetailsReducer, layerReducer }) => ({
  detail: layerDetailsReducer.detail,
  getDetailError: layerDetailsReducer.getDetailError,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    toggleInsightsLayer,
  }, dispatch);

export const Insights = connect(mapStateToProps, mapDispatchToProps)(InsightsAmendment);
